/* ------------------------------------------------------------------
   Mr Football - stop our own controls from being mistaken for a
   variant change.

   THE BUG (reproduced on the storefront, 2026-10-02)
   --------------------------------------------------
   Three separate symptoms, one cause:

     * SIZE FINDER - type a height, click into the weight field, and the
       whole size guide resets. Both inputs blank, focus thrown back to
       <body>, and the URL gains a ?variant= parameter.

     * COMPLETE THE KIT - pick a size for the suggested shorts and the
       dropdown snaps back; then Add does nothing at all.

     * BUILD YOUR KIT - would lose the typed name, the chosen badges and
       the shorts size the moment any of them fired a change.

   WHY
   The theme renders ALL of these inside
   `.swatches__container.js-variant-selector`, and the whole lot sits
   inside the product's <form action="/cart/add">. The theme delegates
   variant selection off events bubbling out of that container and never
   checks whether the event came from an actual swatch.

   So any `change` from our own controls is read as "the shopper picked a
   variant". The theme re-renders the variant block, and everything inside
   it is destroyed and rebuilt: typed values, focus, the dropdown's
   selection, and - fatally for Complete the kit - the Add button's click
   handler, which was bound to the element that just got thrown away.
   That is why Add appeared dead ONLY after changing the size, and worked
   fine if you pressed it first.

   THE FIX
   Catch `change` and `input` as they bubble out of our blocks and stop
   them there. Bubble phase on the block itself, NOT capture phase on
   document: a capture-phase stopPropagation at document would kill the
   event before our own handlers ever ran, breaking the very things this
   is meant to protect.

   `click` is deliberately NOT blocked. The size finder's result panel
   offers a button that selects the suggested size on the real variant
   picker, and the kit builder needs the add-to-cart click to reach the
   theme once it has added its extras.

   Re-attaches on DOM changes, because a legitimate variant change still
   re-renders the container and would otherwise drop the listeners.

   TO REVERT: delete this file and its <script> tag in
   snippets/size-chart-block.liquid.
------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__mfVariantGuard) { return; }
  window.__mfVariantGuard = true;

  /* Every block of ours that lives inside .js-variant-selector and owns
     its own form controls. Add to this list, do not remove from it.
     NOTE: the kit builder's hidden properties[] inputs are appended to the
     product form itself, not inside .mf-kb, so they are untouched by this
     and still submit normally. */
  var REGIONS = '[data-mf-size-finder], .mf-ctk, [data-mf-kit-builder]';
  var BLOCKED = ['change', 'input'];

  function swallow(ev) { ev.stopPropagation(); }

  function attach() {
    var nodes;
    try { nodes = document.querySelectorAll(REGIONS); } catch (e) { return; }
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute('data-mf-guarded') === '1') { continue; }
      el.setAttribute('data-mf-guarded', '1');
      for (var j = 0; j < BLOCKED.length; j++) {
        el.addEventListener(BLOCKED[j], swallow, false);
      }
    }
  }

  attach();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  }
  window.addEventListener('load', attach);

  try {
    var mo = new MutationObserver(function () { attach(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
